import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import CloseBtn from "../CloseBtn";

const STATUS_OPTIONS = ["Active", "Inactive"]; // tweak if you use boolean

const CourierModal = ({
  show,
  onHide,
  isEdit, // pass the whole editing object or falsey
  form,
  setForm,
  saveCourier,
  errors = {},
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header>
        <Modal.Title>{isEdit ? "Edit Courier" : "Add Courier"}</Modal.Title>
      </Modal.Header>
      <CloseBtn onClick={onHide} color="#bf352b" />

      <Form onSubmit={saveCourier}>
        <Modal.Body>
          <div className="d-grid columns-2 gap-3">
            <Form.Group controlId="courier_name">
              <Form.Label>Courier Name*</Form.Label>
              <Form.Control
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="short_name">
              <Form.Label>Short Name*</Form.Label>
              <Form.Control
                value={form.short_name}
                onChange={(e) =>
                  setForm({ ...form, short_name: e.target.value })
                }
                isInvalid={!!errors.short_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.short_name}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="website">
              <Form.Label>Website</Form.Label>
              <Form.Control
                placeholder="https://example.com"
                value={form.website}
                onChange={(e) => setForm({ ...form, website: e.target.value })}
                isInvalid={!!errors.website}
              />
              <Form.Control.Feedback type="invalid">
                {errors.website}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="tracking">
              <Form.Label>Tracking URL</Form.Label>
              <Form.Control
                placeholder="https://example.com/track/{awb}"
                value={form.tracking_url}
                onChange={(e) =>
                  setForm({ ...form, tracking_url: e.target.value })
                }
                isInvalid={!!errors.tracking_url}
              />
              <Form.Control.Feedback type="invalid">
                {errors.tracking_url}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="service_type">
              <Form.Label>Service Type</Form.Label>
              <Form.Control
                placeholder="Surface/Air/Express/International..."
                value={form.service_type}
                onChange={(e) =>
                  setForm({ ...form, service_type: e.target.value })
                }
                isInvalid={!!errors.service_type}
              />
              <Form.Control.Feedback type="invalid">
                {errors.service_type}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="rate_card_ref">
              <Form.Label>Rate Card Ref</Form.Label>
              <Form.Control
                placeholder="e.g., RC-2025-01"
                value={form.rate_card_ref}
                onChange={(e) =>
                  setForm({ ...form, rate_card_ref: e.target.value })
                }
                isInvalid={!!errors.rate_card_ref}
              />
              <Form.Control.Feedback type="invalid">
                {errors.rate_card_ref}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="api_detail" className="span-2">
              <Form.Label>API Details (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder='{"baseUrl":"...","key":"...","secret":"..."}'
                value={form.api_details}
                onChange={(e) =>
                  setForm({ ...form, api_details: e.target.value })
                }
                isInvalid={!!errors.api_details}
              />
              <Form.Control.Feedback type="invalid">
                {errors.api_details}
              </Form.Control.Feedback>
              <div className="form-text">
                Store JSON config here; validate in backend.
              </div>
            </Form.Group>
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={form.status}
                onChange={(e) => setForm({ ...form, status: e.target.value })}
                isInvalid={!!errors.status}
              >
                <option value="">Select status</option>
                {STATUS_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.status}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="remarks">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                value={form.remarks}
                onChange={(e) => setForm({ ...form, remarks: e.target.value })}
                isInvalid={!!errors.remarks}
              />
              <Form.Control.Feedback type="invalid">
                {errors.remarks}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CourierModal;
